<template>
  <v-card elevation="0">
    <loading-block v-if="!loaded"></loading-block>
    <div v-else>
      <v-row>
        <v-col>
          <v-form ref="updateForm" lazy-validation>
            <v-select
              v-model="form.product_form"
              :rules="normalValidation"
              :items="[
                { text: 'Dried Flower', value: 'dried flower' },
                { text: 'Pre Rolled', value: 'pre rolled' },
                { text: 'Oil', value: 'oil' },
                { text: 'Capsules', value: 'capsules' },
                { text: 'Spray', value: 'spray' },
                { text: 'Edible', value: 'edible' },
                { text: 'Beverages', value: 'beverages' },
                { text: 'Topical', value: 'topical' },
                { text: 'Accessories', value: 'accessories' },
                { text: 'Vapes', value: 'Vapes' },
                { text: 'Other', value: 'other' }
              ]"
              label="Product form"
            ></v-select>

            <v-text-field
              v-model="form.consumption_method"
              :rules="normalValidation"
              name="Consumption method"
              label="Consumption method"
              required
              validate-on-blur
              type="text"
            ></v-text-field>
            <v-select
              v-model="form.plant_type"
              :rules="normalValidation"
              :items="[
                      {
                        text: 'Indica',
                        value: 'indica',
                      },
                      {
                        text: 'Sativa',
                        value: 'sativa',
                      },
                      {
                        text: 'Hybrid',
                        value: 'hybrid',
                      },
                      {
                        text: 'Blend',
                        value: 'blend',
                      }
                    ]"
              label="Product type"
            ></v-select>

            <v-select
              v-model="form.hybrid_type"
              :rules="normalValidation"
              :items="[
                      {
                        text: 'Indica dominant',
                        value: 'indica dominant',
                      },
                      {
                        text: 'Sativa dominant',
                        value: 'sativa dominant',
                      },
                      {
                        text: 'Balanced',
                        value: 'balanced',
                      },

                    ]"
              label="Hybrid type"
            ></v-select>
          </v-form>
        </v-col>
      </v-row>
      <v-row class="pa-5">
        <v-col sm="9" md="9"></v-col>
        <v-col sm="3" md="3" class="text-right">
          <template v-if="type=='add'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="addAttribute()"
                  v-on="on"
                  small
                  dark
                  color="primary"
                  class="mr-2"
                  depressed
                >Add</v-btn>
              </template>
              <span>ADD</span>
            </v-tooltip>
          </template>

          <template v-if="type=='delete'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="updateAttribute()"
                  v-on="on"
                  small
                  dark
                  color="primary"
                  class="mr-2"
                  depressed
                >Update</v-btn>
              </template>
              <span>UPDATE</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="deleteAttribute()"
                  v-on="on"
                  small
                  dark
                  color="primary"
                  class="mr-2"
                  depressed
                >Delete</v-btn>
              </template>
              <span>DELETE</span>
            </v-tooltip>
          </template>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script>
import { ProductAPI } from '@/clients/product/product.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      normalValidation: [
        v => !!v || 'Field is required'
      ],
      textValidation: [
        v => !!v.replace(/\s/g, '') || 'Field is required'
      ],
      type: 'add',
      loaded: false,
      form: {
        product_form: '',
        consumption_method: '',
        plant_type: '',
        hybrid_type: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      activeItem: 'product/activeItem'
    })
  },
  watch: {

  },
  mounted() {
    this.spinner(false)
    if (!_.isEmpty(this.activeItem)) {
      this.fetchAndSync()
    }
  },
  methods: {
    /**
     * Fetch and sync attribute
     */
    async fetchAndSync() {
      try {
        let res = await ProductAPI.fetchCannabisAttributes(this.activeItem.id)
        // Has data, assign
        this.type = 'delete'
        for (let key in this.form) {
          this.form[key] = res.data.payload[key]
        }
        this.loaded = true
      } catch (err) {
        // New data
        this.type = 'add'
        this.loaded = true
      }
    },

    /**
     * Add
     */
    async addAttribute() {
      if (this.$refs['updateForm'].validate()) {
        try {
          this.spinner(true)
          let res = await ProductAPI.insertCannabisAttributes(this.activeItem.id, this.form)
          this.spinner(false)
          if (res.status === 200) {
            this.type = 'delete'
          }
          this.snackbar({
            text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     *  Update
    */
    async updateAttribute() {
      if (this.$refs['updateForm'].validate()) {
        try {
          this.spinner(true)
          let res = await ProductAPI.editCannabisAttributes(this.activeItem.id, this.form)
          this.spinner(false)
          this.snackbar({
            text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     * Delete
     */
    deleteAttribute() {
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete cannabis attribute.`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        customClass: {
          container: 'custom-swal'
        }
      }).then(async function (result) {
        if (result.value) {
          try {
            self.spinner(true)
            let res = await ProductAPI.deleteCannabisAttributes(self.activeItem.id)
            self.spinner(false)
            if (res.status === 200) {
              this.type = 'add'
              // reset  form values
              self.$refs['updateForm'].reset()
              self.$swal(
                'Deleted!',
                `Successfully deleted.`,
                'success'
              )
            } else {
              self.$swal(
                'Failed!',
                'Please try again later.',
                'error'
              )
            }
          } catch (err) {
            self.spinner(false)
            self.snackbar({
              text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
              open: true,
              color: 'error'
            })
          }
        }
      })
    },
    ...mapActions({
    })
  }
}
</script>
